"use strict";
/* global window self */
Object.defineProperty(exports, "__esModule", { value: true });
exports.isProduction = exports.isNode = exports.isWebWorker = exports.isBrowser = void 0;
function isBrowser() {
    return typeof window !== 'undefined';
}
exports.isBrowser = isBrowser;
/* eslint-disable no-restricted-globals */
function isWebWorker() {
    var _a;
    return (typeof self === 'object' &&
        ((_a = self === null || self === void 0 ? void 0 : self.constructor) === null || _a === void 0 ? void 0 : _a.name) === 'DedicatedWorkerGlobalScope');
}
exports.isWebWorker = isWebWorker;
/* eslint-enable no-restricted-globals */
function isNode() {
    var _a;
    return typeof process !== 'undefined' && ((_a = process === null || process === void 0 ? void 0 : process.versions) === null || _a === void 0 ? void 0 : _a.node) != null;
}
exports.isNode = isNode;
function isProduction() {
    return process.env.NODE_ENV === 'production';
}
exports.isProduction = isProduction;
//# sourceMappingURL=env-util.js.map